import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Button from '../../../../../components/Buttons/Button';
import { demoPagePath } from '../../../../../utils/helpers';

const ScheduleDemo = ({ title, buttonText = 'Schedule a Demo', className }) => (
  <div className={cx('schedule-demo', className)}>
    {title && <p className="schedule-demo__title">{title}</p>}

    <Button size="lg" href={demoPagePath()} className="schedule-demo__btn">
      {buttonText}
    </Button>
  </div>
);

ScheduleDemo.propTypes = {
  title: T.string,
  buttonText: T.string,
  className: T.string,
};

export default ScheduleDemo;
